import { Component, HostListener } from '@angular/core';
import { BackGroundService } from './background.service';
import { AuthService } from '../auth.service';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';


@Component({
  selector: 'twofactor-config',
  templateUrl: 'two-factorConfig.template.html'
})
export class TwoFactorConfigComponent extends BaseComponent {

  public background: any;
  private codeValid = false;

  constructor(private backGroundService: BackGroundService, private authService: AuthService, private router: Router) {
    super();
    this.background = this.calculateBackground();
  }

  public calculateBackground() {
    return this.backGroundService.getLastBackground();
  }

  public goToMainPage(validCode: boolean): void {
    this.codeValid = validCode;
    if (validCode) {
      this.router.navigate(['']);
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  public logout(): void {
    this.authService.logout(false);
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.codeValid) {
      // se sale de la pantalla sin haber configurado el doble factor -> hacer logout
      this.logout();
    }
    return true;
  }

}

